import { render, staticRenderFns } from "./LeaderboardProfileCard.vue?vue&type=template&id=d382dd44&scoped=true&"
import script from "./LeaderboardProfileCard.vue?vue&type=script&lang=js&"
export * from "./LeaderboardProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardProfileCard.vue?vue&type=style&index=0&id=d382dd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d382dd44",
  null
  
)

export default component.exports